import { Injectable } from '@angular/core';
import { RegbpService } from '../api/src/app/services/regbp.service';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Organisation } from '../api/src/app/models/REGBP-V1.0.0/organisation.model';
import { v4 as uuidGenerator } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class OrganisationFacade {
  constructor(public regbpService: RegbpService) {}

  getOrganisations(): Observable<Organisation[]> {
    return this.regbpService.getOrganisation(null).pipe(
      map((results: any) => results.$response.body.values)
    );
  }

  getOrganisation(kbo: string, legalFormIds: string[]): Observable<Organisation> {
    return this.regbpService.getOrganisation(kbo).pipe(
      map((results: any) => results.$response.body.values),
      map((values: any) => {

        // console.log(values);
        const organisations = (values as Organisation[]);
        if (organisations.length > 0) {
          //We need to check if the legalForm on the organisation in known to us if not we set it to default id 45
          const org = organisations[0];
          //if no id is present yet set a new one => cfr:  https://axidev.atlassian.net/browse/CRBP-1559 
          if(!org.id){
            org.id = uuidGenerator();
          }
          if(!!org.legalForm && !!legalFormIds){
            const legalFormExists = legalFormIds.find(x => x === org.legalForm);
            //If legalForm is not known to us we set it to default 45
            if(!legalFormExists){
              org.legalForm = '45';
            }
          }else {
            //If no legalForm was preset to begin with set to 45 (other)
            org.legalForm = '45';
          }
          return org;
        } else {
          return null;
        }
      }
    ));
  }

}
